<!-- <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()"> -->
<mat-accordion>
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header style="background: #F58634;">
            <mat-panel-title>Booking</mat-panel-title>
        </mat-expansion-panel-header>

        <form>
            <div class="row">
                <div class="col-sm-5">
                    <form [formGroup]="coordinatesForm">
                        <div class="input-fileds-container mt-0">
                            <div class="group mb-0">
                                <div>
                                    <mat-form-field
                                        class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                                        flex-gt-sm>
                                        <input style="color: black; float: right;" formControlName="from_area_name"
                                            (change)="onInputPickUpchange()" #pickUpLocationSearchField matInput
                                            type="text" placeholder="Pickup Area, City" required>
                                     
                                    </mat-form-field>
                                </div>
                                <mat-form-field
                                    class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                                    flex-gt-sm>
                                 
                                    <input (change)="onDropChange()" style="color: black; float: right;"
                                        formControlName="to_area_name" #dropLocationSearchField matInput type="text"
                                        placeholder="Dropup Area, City" required>
                                 
                                </mat-form-field>
                                <mat-form-field
                                    class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                                    flex-gt-sm>
                                    <mat-datepicker-toggle matSuffix [for]="picker1">
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                    <input matInput [matDatepicker]="picker1" placeholder="Pickup Date" [max]="today"
                                        formControlName="date">
                                </mat-form-field>
                                <div>
                                    <mat-form-field
                                        class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width truck-type-input"
                                        flex-gt-sm>
                                        <mat-select dropLocationSearchField placeholder="Truck Category"
                                            formControlName="truck_category_name" (selectionChange)="GetTruckWeight()"
                                            required>
                                            <mat-option>Select Truck category</mat-option>
                                            <mat-option *ngFor='let cat of truckCategory' value="{{cat._id}}">
                                                {{cat.truck_category_name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field
                                        class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                                        flex-gt-sm>
                                        <mat-select dropLocationSearchField placeholder="Weight"
                                            formControlName="truck_type" required>
                                            <mat-option value=''>Select Weight</mat-option>
                                            <mat-option *ngFor='let item of truckWeight' value="{{item._id}}">
                                                {{item.truck_weight}}, {{ item.truck_feet }}, {{ item.minimum_amount }} W</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row p-0">
                            <button class="sheer" (click)="requestQuote()">Search</button>
                        </div>
                    </form>
                </div>
                <div class="col-sm-6">
                    <div tabindex="0" aria-label="Map" class="map" id="map">
                        <google-map width="100%" [center]="inititalCoordinates" [options]="mapConfigurations">
                        </google-map>
                    </div>
                </div>
            </div>
        </form>
    </mat-expansion-panel>
</mat-accordion>